import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getQuizById, getQuizIdsByScenario } from "../../api/quiz";
import { SERVER_URL } from "../../api";
import arrowLeft from "../../assets/arrow-left.png";
import arrowRight from "../../assets/arrow-right.png";
import buttonAmpliar from "../../assets/button-ampliar.png";
import NextButton from "../../components/NextButton";
import ScenarioBar from "../../components/ScenarioBar";
import { useLang } from "../../translations/i18n";
import { QUIZZES, ROUTES, SCENARIOS } from "../../utils/constants";
import { getScenarioByScreen } from "../../utils/helpers";
import { modalImage } from "../../utils/logger";

const QUIZ_ID = QUIZZES.SCENARIO3;
const SCENARIO_ID = SCENARIOS.SCENARIO_3;

function buildImageUrl(value) {
	if (!value || typeof value !== "string") return null;
	if (value.startsWith("http")) return value;
	return `${SERVER_URL.replace(/\/$/, "")}/${value.replace(/^\//, "")}`;
}

function Scenario3Explanation({ intl }) {
	const lang = useLang();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const participant = useSelector((state) => state.group);
	const cachedQuiz = useSelector((state) => state.quizCache?.[SCENARIO_ID]);

	const scenarioNum = getScenarioByScreen(location.pathname);

	const [options, setOptions] = useState([]);
	const [activeImage, setActiveImage] = useState(null);
	const [quizLoading, setQuizLoading] = useState(true);

	useEffect(() => {
		const gameId = participant?.game;
		if (!gameId) {
			setQuizLoading(false);
			return;
		}

		// Usar caché si se precargó desde la pantalla anterior
		if (cachedQuiz?.data?.options?.length >= 4) {
			const opts = cachedQuiz.data.options.slice().sort((a, b) => (a.id || 0) - (b.id || 0));
			const mapped = opts.map((o) => ({
				id: o.id,
				text: o.text || "",
				image: buildImageUrl(o.image) || null,
			}));
			setOptions(mapped);
			setActiveImage(buildImageUrl(opts[0]?.image) || null);
			setQuizLoading(false);
			return;
		}

		const params = { game: gameId };
		setQuizLoading(true);
		let cancelled = false;
		getQuizIdsByScenario(SCENARIO_ID, params)
			.then((listRes) => {
				if (cancelled) return;
				const list = listRes?.data && Array.isArray(listRes.data) ? listRes.data : [];
				const id = list[0]?._id || QUIZ_ID;
				return getQuizById(id);
			})
			.then((res) => {
				if (cancelled) return;
				if (res?.status === 200 && res.data?.options?.length >= 4) {
					const opts = res.data.options.slice().sort((a, b) => (a.id || 0) - (b.id || 0));
					const mapped = opts.map((o) => ({
						id: o.id,
						text: o.text || "",
						image: buildImageUrl(o.image) || null,
					}));
					setOptions(mapped);
					setActiveImage(buildImageUrl(opts[0]?.image) || null);
				}
				setQuizLoading(false);
			})
			.catch(() => { if (!cancelled) setQuizLoading(false); });
		return () => { cancelled = true; };
	}, [participant?.game]);

	const ImageCarousel = () => {
		const images = options?.map((x) => x.image) ?? [];
		const activeIndex = images.findIndex((x) => x === activeImage);

		const nextImage = () => {
			if (!images.length) return;
			const nextIndex = (activeIndex + 1) % images.length;
			setActiveImage(images[nextIndex]);
		};

		const prevImage = () => {
			if (!images.length) return;
			const prevIndex = (activeIndex - 1 + images.length) % images.length;
			setActiveImage(images[prevIndex]);
		};

		return (
			<div className="d-flex align-items-center">
				<img onClick={prevImage} src={arrowLeft} alt="" />
				<div className="image-carousel-container d-flex justify-content-center w-100 mx-3">
					{activeImage ? (
						<img height={400} src={activeImage} alt="" />
					) : (
						<div style={{ width: "100%", height: 400, background: "#e0e0e0", borderRadius: 8 }} aria-hidden />
					)}
					{activeImage && (
						<div
							style={{
								position: "absolute",
								bottom: "5%",
								right: "5%",
							}}
						>
							<img
								onClick={() => modalImage({ image: activeImage })}
								width={70}
								src={buttonAmpliar}
								alt=""
							/>
						</div>
					)}
				</div>
				<img onClick={nextImage} src={arrowRight} alt="" />
			</div>
		);
	};

	if (quizLoading) {
		return (
			<div className="h-100 bg-prueba d-flex align-items-center justify-content-center">
				<div className="txtWhite">Cargando...</div>
				<ScenarioBar activeScenario={scenarioNum} />
			</div>
		);
	}

	if (!options?.length) {
		return (
			<div className="h-100 bg-prueba d-flex align-items-center justify-content-center">
				<div className="txtWhite">No hay opciones configuradas.</div>
				<ScenarioBar activeScenario={scenarioNum} />
			</div>
		);
	}

	return (
		<div className="h-100 bg-prueba">
			<div className="container">
				<div className="row h-100">
					<div className="row d-flex justify-content-center align-items-center my-4">
						<div className="col-8 px-4">
							<ImageCarousel />
						</div>
						<div className="col-4">
							{options?.find((x) => x?.image === activeImage) && (
								<div className="txt-white txt20">
									{options.find((x) => x?.image === activeImage).text}
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
			<div
				className="container"
				style={{
					position: "absolute",
					bottom: "13vh",
					zIndex: 1000,
				}}
			>
				<div className="d-flex justify-content-end">
					<NextButton navigateTo={ROUTES.SCENARIO3_RESULT} />
				</div>
			</div>
			<ScenarioBar activeScenario={scenarioNum}></ScenarioBar>
		</div>
	);
}

export default injectIntl(Scenario3Explanation);
